export default {
    bindings: {
        title: '@'
    },
    controller: 'basketCreateController',
    template: require('../views/basket.create.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/basket.create.component.js